import React from 'react';
import { useSelector } from 'react-redux';
import pluralize from 'pluralize';

import {
  getUpdatedPauseDuration,
  LearnerEmailBadge,
  selectedRequestSelector,
  updateDurationMonthsBySelector,
  updateDurationTypeSelector,
} from 'features/courseResume';
import styles from './EditDurationModalUpdateStage.module.scss';
import UpdateDurationButton from '../UpdateDurationButton';
import UpdateDurationByMonthsField from '../UpdateDurationByMonthsField';
import UpdateDurationSourceField from '../UpdateDurationSourceField';
import UpdateDurationTypeField from '../UpdateDurationTypeField';

function EditDurationModalUpdateStage() {
  const updateDurationBy = useSelector(updateDurationMonthsBySelector);
  const updatedDurationType = useSelector(updateDurationTypeSelector);
  const selectedRequest = useSelector(selectedRequestSelector);
  const { duration_of_pause: durationOfPause, mentee } = selectedRequest;
  const {
    user: { email },
  } = mentee;
  const updatedDuration = getUpdatedPauseDuration(
    durationOfPause,
    updatedDurationType,
    updateDurationBy?.value
  );

  return (
    <div className={styles.root}>
      <div className="h2 dark bold m-b-s">Edit Duration</div>
      <UpdateDurationTypeField />
      <UpdateDurationByMonthsField />
      <UpdateDurationSourceField />
      <div className="row m-b-s">
        <div className={styles.updated}>
          Updated Pause Duration
          <span className={styles.updatedDuration}>
            {pluralize('Month', updatedDuration, true)}
          </span>
        </div>
        <LearnerEmailBadge email={email} />
      </div>
      <UpdateDurationButton />
    </div>
  );
}

export default EditDurationModalUpdateStage;
